import axios from 'axios';

const BASE_URL = process.env.VUE_APP_API_ENDPOINT;

/**
 * Checks if an email already exists and returns the appropriate action.
 *
 * Returns:
 *   { proceed: true }                          - email not found or API error (never blocks on failure)
 *   { proceed: false, reason: 'paid_user' }    - existing paid account
 *   { proceed: false, reason: 'wrong_role', role: string } - non-USER role
 */
export async function checkEmail(email) {
    try {
        const response = await axios.post(`${BASE_URL}/api/check-email`, { email });
        const data = response.data;

        if (!data.success || !data.email_found) {
            return { proceed: true };
        }

        // Email found — check role first
        if (data.user_role && data.user_role !== 'USER') {
            return { proceed: false, reason: 'wrong_role', role: data.user_role };
        }

        // Email found, correct role — check paid status
        if (data.paid_user) {
            return { proceed: false, reason: 'paid_user' };
        }

        // Email found, not paid, role is USER — continue
        return { proceed: true };
    } catch (error) {
        console.error('Email check failed:', error);
        return { proceed: true };
    }
}
